// SortHeader — a sortable <th>. Shows a direction caret for the active column
// and toggles asc/desc via onSort. Internal to DataTable but exported for
// custom table layouts.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { CaretIcon, ChevronUpIcon, ChevronDownIcon } from '../../icons/Icons';

export function SortHeader({ column, sort, onSort }) {
  const { key, label, align = 'left', numeric, sortable = true } = column;
  const active = sort?.key === key;
  const dir = active ? sort.dir : null;

  if (!sortable) {
    return <th className={cx('data-table__th', numeric && 'is-numeric', `is-${align}`)}>{label}</th>;
  }

  const nextDir = active && dir === 'asc' ? 'desc' : 'asc';
  // SVG chevron mark: up/down for the active column, a muted caret otherwise.
  const Mark = active ? (dir === 'asc' ? ChevronUpIcon : ChevronDownIcon) : CaretIcon;
  return (
    <th
      className={cx('data-table__th', 'is-sortable', numeric && 'is-numeric', `is-${align}`, active && 'is-active')}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className="data-table__sort-btn" onClick={() => onSort({ key, dir: nextDir })}>
        {label}
        <Mark className="data-table__caret" aria-hidden="true" />
      </button>
    </th>
  );
}

SortHeader.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.node,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    numeric: PropTypes.bool,
    sortable: PropTypes.bool,
  }).isRequired,
  sort: PropTypes.shape({ key: PropTypes.string, dir: PropTypes.oneOf(['asc', 'desc']) }),
  onSort: PropTypes.func.isRequired,
};

export default SortHeader;
